import { Asset, useUgla3dStateManager } from "@ugla-france/ugla-3d-library";
import { useEffect, useState } from "react";
import styled from "styled-components";
import ColorSelector from './ColorSelector';
import Carrousel from "./Carrousel";
import { getTag } from "../helpers/getTags";
import DropdownMenu from "./DropDownMenu";
import { TbView360Number } from "react-icons/tb";
import { BsDoorClosed, BsDoorOpen, BsBadge3D  } from "react-icons/bs";

interface BottomBarProps {
    onStateChange: (state: string) => void;
    onColorStateChange: (color: string) => void;
    on360Change: (equi: boolean) => void;
    onPovChange?: (pov: number) => void;
    onCarouselClick?: () => void;
    currentKitchen?: string;
}


const BottomBar: React.FC<BottomBarProps> = ({ onStateChange, onColorStateChange, on360Change, onPovChange, onCarouselClick, currentKitchen }) => {
    const [open, setOpen] = useState('close');
    const [color, setColor] = useState('#B27B65FF');
    const stateManager = useUgla3dStateManager();
    const state = stateManager.getModel();
    const [items, setItems] = useState<Asset[]>([]);
    const [show360, setShow360] = useState(false);
    
    const handleCarouselClick = () => {
        setShow360(false);
        if (onCarouselClick) {
            onCarouselClick();
        }
    };
    // const items = [
    //     { imageUrl: "https://store.fms.staging.ugla.tech/public/demoFBD/kitchen_face_1.png", name: "Image 1" },
    //     { imageUrl: "https://store.fms.staging.ugla.tech/public/demoFBD/kitchne_1_face_1.png", name: "Image 2" },
    //     { imageUrl: "url3.jpg", name: "Image 3" },
    //     { imageUrl: "url3.jpg", name: "Image 3" },
    // ];
    useEffect(() => {
        setOpen('close');
    }, []);
    useEffect(() => {
        
        console.log("current state", open);
        const _items : { imageUrl: string; name: string }[] = [];
        const currentAsset = state.getContent().assets.filter((asset) => {
            if (currentKitchen) {
                const nameTag = asset.tags?.find((tag) => tag.key === 'name');
                if (nameTag?.value !== currentKitchen) return false;
            }
            return true;
        }).filter((asset) => {
            const colorTag = asset.tags?.find((tag) => tag.key === 'color');
            return colorTag?.value === color;
        }).filter((asset) => {
            const stateTag = asset.tags?.find((tag) => tag.key === 'state');
            return stateTag?.value === open;
        }).sort((a, b) => {
            const povA = parseInt(a.tags?.find(tag => tag.key === 'pov')?.value || '0', 10);
            const povB = parseInt(b.tags?.find(tag => tag.key === 'pov')?.value || '0', 10);
            return povA - povB;
        });
        currentAsset.forEach(asset => {
            _items.push({ imageUrl: asset.url, name: getTag('name', asset.tags, 'Unknown') || 'Unknown' });
        });
        // currentAsset.push(...currentAsset);
        setItems(currentAsset);
        onStateChange(open);
        onColorStateChange(color);
        on360Change(show360);

    }, [stateManager, state, color, open, show360, currentKitchen]);
    const toggleOpenClose = () => {
        setOpen((prevState) => (prevState === 'open' ? 'close' : 'open'));
        // onStateChange(open);
        console.log("current state triggering change", open);
    }
    const changeColor = (color: string) => {

        setColor(color);
        // onColorStateChange(color);
    }
    return (
        <Container>
            <TopContainer>
                <DropdownMenu options={['Portes', 'Poignées', 'Corps', 'Plans de travail', 'Crédences', 'Éléments hauts', 'Fours', 'Table de cuisson', 'Hottes', 'Mitigeurs', 'Murs', 'Sols']}></DropdownMenu>
                <Carrousel items={items} onPovChange={onPovChange} onCarouselClick={handleCarouselClick}></Carrousel>
                <Container360 onClick={() => setShow360(!show360)}>
                    <TbView360Number color="#006ab2" size={'5rem'} />
                </Container360>
                <StateButton onClick={() => window.open(
                    currentKitchen === 'Campagne'
                        ? 'https://vab.staging.ugla.tech/editor?key=/vab/templates/demo_cuisine_astra_bleu_freeze.ugla' : 'https://vab.staging.ugla.tech/editor?key=/vab/templates/demo_cuisine_gaia_bleu_1.ugla', '_blank')?.focus()} style={{ margin: '1rem' }}>
                    <BsBadge3D size={'2rem'} />
                </StateButton>
            </TopContainer>
            <BottomContainer>
                <MainCont>
                    <TitleContainer>Options disponibles</TitleContainer>
                    <ColorContainer>
                        <ColorSelector onClick={() =>  changeColor('#B27B65FF')} color="#B27B65FF" />
                        <ColorSelector onClick={() =>  changeColor('#606A74FF')} color="#606A74FF" />
                    </ColorContainer>
                </MainCont>
            </BottomContainer>
            <StateButton style={{
                position: 'absolute',
                top: '68%',
                borderRadius: '50%',
                width: '3.5rem',
                height:'3.5rem'
            }} onClick={() => toggleOpenClose()}>{open === 'open' ? <BsDoorOpen size={'2rem'} /> : <BsDoorClosed size={'2rem'} /> }</StateButton>
        </Container>
    );    
}


const MainCont = styled.div`
    display:flex;
    flex-direction:column;
`
const TitleContainer = styled.div`
    margin-bottom:0.3rem;
    display:flex;

`
const ColorContainer = styled.div`
    display:flex;
`
const Container360 = styled.div`
    display:flex;   
    margin-left:1rem;
    margin-right:1rem;
    text-align:center;
    justify-content:center;
    align-items:center;
    &:hover{
        cursor:pointer;
    }
    &:hover {
        transform: scale(0.95);
        transition: all 0.3s;
        cursor:pointer;
    }
`

const TopContainer = styled.div`
    display:flex;
`;
const BottomContainer = styled.div`
    display:flex;
`
const StateButton = styled.div`
    background-clip: padding-box;
    background-color: #006ab2;
    border-radius: 0.5rem;
    box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
    color: #fff;
    display: flex;
    
    flex-direction: column;
    justify-content: center;
    align-items:center;
    border-radius: 0.5rem;
    width: 5rem;
    height: 5rem;
    &:hover,
    &:focus {
    background-color: #13225e;
    box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
    }

    &:hover {
        transform: scale(0.95);
        transition: all 0.3s;
        cursor:pointer;
    }
    &:active{
        transform: translateY(0px);
        box-shadow: none;
        transition: all 0.3s;
    }
    

`
const Container = styled.div`
    display:flex;
    background-color: white;
    padding: 10px;
    height:13rem;
    text-align: center;
    flex-direction: column;
`;
export default BottomBar;